export default {
  ECOMMERCE_NOTIFOCATION_REQUEST: 'APP/ECOMMERCE_NOTIFOCATION/ECOMMERCE_NOTIFOCATION_LIST_REQUEST',
  ECOMMERCE_NOTIFOCATION_SUCCESS: 'APP/ECOMMERCE_NOTIFOCATION/ECOMMERCE_NOTIFOCATION_LIST_SUCCESS',
  ECOMMERCE_NOTIFOCATION_ERROR: 'APP/ECOMMERCE_NOTIFOCATION/ECOMMERCE_NOTIFOCATION_LIST_ERROR',
};
